export default __webpack_public_path__ + "static/media/KitchenAid.0bf55330.jpg";